// rails defaults --------
// import Rails from '@rails/ujs'
import "@hotwired/turbo-rails"
import * as ActiveStorage from '@rails/activestorage'
import './javascript/channels'

// external pacakages --------
import DriftPhotoModule from './drift-photo-module.es.js'
import axios from 'axios'
import Toast from 'bootstrap/js/src/toast'

import { Application } from '@hotwired/stimulus'
const application = Application.start()
import ShowcaseLoaderController from '../controllers/showcase_loader_controller'
application.register('showcase-loader', ShowcaseLoaderController)
import ResetFormController from '../controllers/reset_form_controller'
application.register("reset-form", ResetFormController)

Object.defineProperty(window, 'DriftPhotoModule', {
  value: DriftPhotoModule,
  writable: false
})

Object.defineProperty(window, 'Toast', {
  value: Toast,
  writable: false
})

Object.defineProperty(window, 'getShowcaseThumbnail', {
  value: async () => {
    const targets = document.getElementsByClassName('showcases-card')
    if (targets.length === 0) {
      return
    }

    const csrfHeader = {
      'X-Requested-With': 'XMLHttpRequest',
      'X-CSRF-TOKEN': document.querySelector('meta[name="csrf-token"]') ? document.querySelector('meta[name="csrf-token"]').getAttribute('content') : ''
    }

    await Promise.all(
      Array.from(targets).map(async (target) => {
        const res = await axios.get(target.dataset.getShowcaseThumbnailPath, { headers: csrfHeader })
        if (res?.data?.thumbnail) {
          target.querySelector('.thumbnail-and-operations').style.backgroundImage = `url(${res.data.thumbnail})`
        }
      })
    )
  },
  writable: false
})

// Rails.start() // FIXME: yarn vite buildする環境だと二重読み込みエラーが起きるが、この一行が無いとyarn dev環境では@rails/ujsが死ぬ…
ActiveStorage.start()

document.addEventListener('turbo:load', () => {
  document.querySelector('#showcase-grid-btn')?.addEventListener('click', () => {
    document.querySelector('#showcase-grid').classList.add('active', 'show')
    document.querySelector('#showcase-grid-btn').classList.add('active')
    document.querySelector('#showcase-list').classList.remove('active', 'show')
    document.querySelector('#showcase-list-btn').classList.remove('active')
  })
  document.querySelector('#showcase-list-btn')?.addEventListener('click', () => {
    document.querySelector('#showcase-grid').classList.remove('active', 'show')
    document.querySelector('#showcase-grid-btn').classList.remove('active')
    document.querySelector('#showcase-list').classList.add('active', 'show')
    document.querySelector('#showcase-list-btn').classList.add('active')
  })
})

import './javascript/shared'
import './javascript/showcase'
